module.exports = __webpack_public_path__ + "img/sonargroup-main.babb9438.webp";